export default __webpack_public_path__ + "images/FB.5d54286.png";